import * as React from 'react';

import { useAtomValue } from 'jotai';

import { useFilesystemChangedSubscription } from './_graphql/subscriptions/filesystemChangedSubscription';
import { $remoteFiles } from './_state/files.state';
import { $directoryList } from './_state/fileTree.state';

/**
 * FilesSubscriptionProvider
 *
 * Manages the GraphQL subscription for file system changes and automatically
 * refreshes file queries when events are received from other modules.
 *
 * This provider ensures that when files are created, updated, deleted, or moved
 * from ANY module (not just the files module), the file explorer updates in real-time.
 */
export const FilesSubscriptionProvider: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  // Get query instances to trigger refetch
  const filesQuery = useAtomValue($remoteFiles);
  const directoryListQuery = useAtomValue($directoryList);

  // Subscribe to file system changes (orgId from auth claims)
  const { error } = useFilesystemChangedSubscription(undefined, {
    onEvent: (_event) => {
      // Refetch files to show the changes
      filesQuery.refetch();

      // Refetch directory tree to update folder structure
      directoryListQuery.refetch();
    },
  });

  // Log subscription errors
  React.useEffect(() => {
    if (error) {
      console.error('[FilesSubscriptionProvider] Subscription error:', error);
    }
  }, [error]);

  return children;
};
